import { render, staticRenderFns } from "./PremiumRestriction.vue?vue&type=template&id=2d0b463e&scoped=true&"
import script from "./PremiumRestriction.vue?vue&type=script&lang=js&"
export * from "./PremiumRestriction.vue?vue&type=script&lang=js&"
import style0 from "./PremiumRestriction.vue?vue&type=style&index=0&id=2d0b463e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b463e",
  null
  
)

export default component.exports